import { Box, Dialog, IconButton, Typography, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: alpha(theme.palette.common.black, 0.46),
  },
  '& .MuiPaper-root': {
    position: 'relative',
    borderRadius: '16px',
    padding: '26px 26px 22px',
    minWidth: '320px',
    maxWidth: '412px',
    boxShadow: '0 28px 64px -20px rgba(16, 18, 27, 0.42), 0 2px 6px rgba(16, 18, 27, 0.08)',
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '16px',
  right: '16px',
  width: '28px',
  height: '28px',
  padding: 0,
  borderRadius: '8px',
  color: theme.palette.grey[500],
  '& .MuiSvgIcon-root': {
    fontSize: '18px',
  },
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[900],
  },
}));

export const DialogHeader = styled(Typography)(({ theme }) => ({
  fontSize: '19px',
  fontWeight: 600,
  letterSpacing: '-0.01em',
  lineHeight: 1.3,
  color: theme.palette.grey[950],
  textAlign: 'left',
  paddingRight: '26px',
  marginBottom: '10px',
  fontFamily: 'Neue Frutiger World',
}));

export const DialogMessage = styled(Box)(({ theme }) => ({
  fontSize: '14.5px',
  lineHeight: 1.55,
  color: theme.palette.grey[800],
  textAlign: 'left',
  textWrap: 'pretty',
  marginBottom: '24px',
  fontFamily: 'Neue Frutiger World',
}));

export const ButtonContainer = styled(Box)({
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
  width: '100%',
});
